import React from "react";

export default function NavBarBrand () {
  return (
    <div className="nav-bar__brand">
      <a
        href="https://tarterware.com"
        rel="noopener noreferrer"
      >
        <img
          className="nav-bar__logo"
          src="https://tarterware.com/wp-content/uploads/2024/04/cropped-Gemini_Generated_Image_xnjtxoxnjtxoxnjt.jpeg"
          alt="Tarterware"
          width="60"
          height="60"
        />
      </a>
    </div>
  );
};
